import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function ViewEmailDetail() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2579" data-mp="2a93y84ne9fy1">
      <div className="flex items-center justify-between" data-id="element-2580" data-mp="2a684ksikxdfe">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2581" data-mp="268aezokwcpbh">Email Detail</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/email-details')} data-id="element-2582" data-mp="32xi0iwlimyfe">
          ← Back to Email Details
        </Button>
      </div>

      <Card data-id="element-2583" data-mp="2oy9zdy5slg8k">
        <CardContent className="pt-6" data-id="element-2584" data-mp="2owp3a43txp8l">
          <table className="text-sm w-full" data-id="element-2585" data-mp="2oztbrdobv752">
            <tbody data-id="element-2586" data-mp="1iifzez970mnj">
              <tr className="border-b border-slate-100" data-id="element-2587" data-mp="1iizhqh2r9d23">
                <td className="py-2 pr-6 font-medium text-slate-700 w-24 align-top" data-id="element-2588" data-mp="1dhscaoo34pyl">
                  Id
                </td>
                <td className="py-2 text-slate-900" data-id="element-2589" data-mp="16sbbhqhxg4o4">1</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2590" data-mp="1bqmiltgu812n">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2591" data-mp="1bo0c7x5onrm0">
                  Subject
                </td>
                <td className="py-2 text-slate-900" data-id="element-2592" data-mp="12p6c3wt58j3p">
                  Welcome to Desert Sage Seminars
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2593" data-mp="nzqouqstmvsr">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2594" data-mp="sqyy9mu5ih5x">
                  Body
                </td>
                <td className="py-4 text-slate-800 leading-relaxed max-w-2xl" data-id="element-2595" data-mp="f0vgb82b19ma">
                  <div className="space-y-3" data-id="element-2596" data-mp="j0xhzh81i31k">
                    <p data-id="element-2597" data-mp="j1p3u0bu4men">
                      You have received this notification from{' '}
                      <a href="#" className="text-blue-600 underline" data-id="element-2598" data-mp="526703oh4xhn">
                        Desert Sage Seminars
                      </a>{' '}
                      because you are a registered user. You have successfully
                      registered with Desert Sage Seminars.{' '}
                      <span className="bg-yellow-200 font-bold" data-id="element-2599" data-mp="26yet9i9z7caa">
                        PLEASE SAVE THIS EMAIL FOR YOUR RECORDS.
                      </span>
                    </p>
                    <p data-id="element-2600" data-mp="1xzkyzyk4axzw">
                      Your Username and Password will enable you to enroll in
                      our courses at any time.
                    </p>
                    <p data-id="element-2601" data-mp="2qnguizxyajv3">Your Username is as follows:</p>
                    <table className="border border-slate-300 text-sm" data-id="element-2602" data-mp="2qnyy6hmy00d1">
                      <tbody data-id="element-2603" data-mp="2ln1j4dx8bmfr">
                        <tr data-id="element-2604" data-mp="2lm9n51zpzmoy">
                          <td className="border border-slate-300 px-3 py-1 font-medium" data-id="element-2605" data-mp="2gozyvpo2hh2p">
                            Username:
                          </td>
                          <td className="border border-slate-300 px-3 py-1" data-id="element-2606" data-mp="1aaijaw91nf81">
                            username
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p data-id="element-2607" data-mp="v4318wbk978v">
                      Please remember that the Password you created is case
                      sensitive.
                    </p>
                    <p data-id="element-2608" data-mp="153bshhf1k7rj">You affirmed the following to be true:</p>
                    <ul className="list-disc pl-6 space-y-1 font-bold" data-id="element-2609" data-mp="19vbxho9yxquz">
                      <li data-id="element-2610" data-mp="19wn2frf5h4no">I will be the person taking these classes, and</li>
                      <li data-id="element-2611" data-mp="1dw5m6jv8j9ox">
                        I realize that it is a felony to impersonate a real
                        estate licensee
                      </li>
                      <li data-id="element-2612" data-mp="1nvmp4tj3r9h7">
                        I will not complete more than 9 renewal hours within the
                        same calendar day
                      </li>
                    </ul>
                    <p data-id="element-2613" data-mp="3pmzrpbxll5a3">
                      At any time while taking a course, you will be able to
                      contact Tech Support* should you encounter a problem with
                      our website, or Course Support* should you encounter any
                      issues with the course, the text, quizzes or anything
                      course related.
                    </p>
                    <p data-id="element-2614" data-mp="1xwdzlnh8ls71">
                      * Support will be available 7 days a week from 7:30 AM to
                      9:00 PM Arizona time.
                    </p>
                    <p data-id="element-2615" data-mp="158i24gjufw97">
                      Thank you for registering with Desert Sage Seminars. We
                      are sure you will find our courses to be an efficient and
                      valuable use of your time.
                    </p>
                    <p data-id="element-2616" data-mp="1ezvxcc4ri9wj">Cordially</p>
                    <p className="font-bold" data-id="element-2617" data-mp="1a84havj8fmkn">
                      Jon Kichen, Instructor
                      <br data-id="element-2618" data-mp="mia60ieka62i" />
                      Owner/Administrator
                      <br data-id="element-2619" data-mp="mggyl0w4jhtg" />
                      Desert Sage Seminars
                      <br data-id="element-2620" data-mp="hi5pisdnlbca" />
                      Phone: 602-377-6207
                      <br data-id="element-2621" data-mp="2t6slpn0e0326" />
                      URL: www.DesertSageSeminars.com
                    </p>
                  </div>
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2622" data-mp="2xzdfiojamg5p">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2623" data-mp="2k6x7f9bjbrxx">Param</td>
                <td className="py-2 text-slate-900 font-mono text-xs" data-id="element-2624" data-mp="2p4fgr0tgs96g">
                  sign_in_confirmation
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2625" data-mp="3cvb49lqw0i7w">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2626" data-mp="3gwek488xqe94">
                  Created
                </td>
                <td className="py-2 text-slate-900" data-id="element-2627" data-mp="32vk9rk2bu37t">2011-09-26 12:39:36</td>
              </tr>
            </tbody>
          </table>

          <div className="mt-6 pt-4 border-t border-slate-200 space-y-1" data-id="element-2628" data-mp="37xjfh0ljhc7x">
            <p className="text-sm font-medium text-slate-700" data-id="element-2629" data-mp="1rgf2e2r93ghv">Actions</p>
            <div className="flex flex-col gap-1 text-sm text-blue-600" data-id="element-2630" data-mp="1wgjn64z6yxdw">
              <button className="text-left hover:underline w-fit" onClick={() => navigate('/email-details/edit/1')} data-id="element-2631" data-mp="1ce5juqbofnij">
                Edit Email Detail
              </button>
              <button className="text-left hover:underline text-red-500 w-fit" data-id="element-2632" data-mp="13lbuu16fh9rh">
                Delete Email Detail
              </button>
              <button className="text-left hover:underline w-fit" onClick={() => navigate('/email-details')} data-id="element-2633" data-mp="ym8ugu1e7rpu">
                List Email Details
              </button>
              <button className="text-left hover:underline w-fit" data-id="element-2634" data-mp="oqp56qhc3ra2">
                New Email Detail
              </button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}